export const BlogTagsTableColumns = (isArabic) => [
    { id: 'title', label: isArabic ? 'الوسم' : 'Tag', align: 'start' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];
